import { defineComponent as _defineComponent } from 'vue'
import { mdiEmailOutline, mdiPhone, mdiWeb } from '@mdi/js';
	import DialogBox from '@cnamts/vue-dot/src/elements/DialogBox';
	import { ref } from 'vue';

	import IconText from './icon-text.vue';
	import { ContactCard } from '@/types/contact-card';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'contact-card',
  props: {
    structureContactList: null
  },
  setup(__props: any) {

	

	const isDialogOpen = ref(false);

return { __sfc: true,isDialogOpen, mdiEmailOutline, mdiPhone, mdiWeb, DialogBox, IconText }
}

})